module.exports = __webpack_public_path__ + "static/media/add_app_save.1c2d2ce0.png";